import React from "react";
import { LocalizedText } from "../../i18n/LocalizedText.js";
import { GlideButtonCell } from "./cells/GlideButtonCell.js";
import { GlideChipCell } from "./cells/GlideChipCell.js";
import { GlideToggleCell } from "./cells/GlideToggleCell.js";
import "@glideapps/glide-data-grid";
import "immer";
import "moment-timezone";
import "react-intl";
import "../../icons/Icon.js";
import "../../icons/ExpandMoreIcon.js";
import { GlideCurrencyCell } from "./cells/GlideCurrencyCell.js";
import { GlideLinkCell } from "./cells/GlideLinkCell.js";
import { GlideTextCell } from "./cells/GlideTextCell.js";
import { GlideLocalizedTextCell } from "./cells/GlideLocalizedTextCell.js";
class GlideGridColumnsConverter {
  _formatMessage;
  _formatNumber;
  _navigate;
  constructor(formatMessage, formatNumber, navigate) {
    this._formatMessage = formatMessage;
    this._formatNumber = formatNumber;
    this._navigate = navigate;
  }
  convert(columns, visibleColumns) {
    return columns.filter((c) => visibleColumns === null || visibleColumns === void 0 || visibleColumns.includes(c.field)).map((column) => ({
      id: column.field,
      title: "",
      columnName: column.title ? this._formatMessage(column.title) : "",
      columnTooltip: column.tooltip ?? (column.title ? /* @__PURE__ */ React.createElement(LocalizedText, { label: column.title }) : null),
      sortable: column.sortable,
      cell: this.getDataCell(column),
      width: column.width,
      grow: column.flex
    }));
  }
  getDataCell(column) {
    const columnMap = {
      text: () => new GlideTextCell(column.valueGetter, column.emptySymbol),
      localized_text: () => new GlideLocalizedTextCell(column.valueGetter, this._formatMessage, column.emptySymbol),
      link: () => new GlideLinkCell(column.valueGetter, this._navigate),
      currency: () => new GlideCurrencyCell(column.valueGetter, this._formatNumber, column.emptySymbol),
      button: () => new GlideButtonCell(column.valueGetter),
      action_button: () => {
        throw Error("cell type not implemented");
      },
      modal_button: () => {
        throw Error("cell type not implemented");
      },
      action_with_confirmation_button: () => {
        throw Error("cell type not implemented");
      },
      chip: () => new GlideChipCell(column.valueGetter, column.emptySymbol),
      toggle: () => new GlideToggleCell(column.valueGetter)
    };
    return columnMap[column.type]();
  }
}
export {
  GlideGridColumnsConverter
};
//# sourceMappingURL=GlideGridColumnsConverter.js.map
